// ── Crit Roster i18n ────────────────────────────────────────────
// All UI strings in DE (default) and EN.
// Usage: import { useT } from './i18n'; const t = useT();

import { useContext } from 'react';
import { LangContext } from './context/LangContext';

const translations = {

  // ── Navigation ──────────────────────────────────────────────────
  nav_dashboard:       { de: 'Dashboard',      en: 'Dashboard' },
  nav_drivers:         { de: 'Fahrer',          en: 'Riders' },
  nav_events:          { de: 'Unsere Events',   en: 'Our Events' },
  nav_matrix:          { de: 'Race Matrix',     en: 'Race Matrix' },
  nav_notifications:   { de: 'Benachrichtigungen', en: 'Notifications' },
  nav_profile:         { de: 'Profil',          en: 'Profile' },
  nav_settings:        { de: 'Einstellungen',   en: 'Settings' },
  nav_logout:          { de: 'Abmelden',        en: 'Log out' },
  nav_install_app:     { de: 'APP INSTALLIEREN', en: 'INSTALL APP' },
  nav_install_hint_android: { de: 'Als App installieren für schnellen Zugriff.', en: 'Install as app for quick access.' },
  nav_install_hint_ios:     { de: 'Zum Home-Bildschirm hinzufügen für schnellen Zugriff.', en: 'Add to Home Screen for quick access.' },
  nav_ios_step1:       { de: 'Tippe auf das Teilen-Symbol in der Safari-Menüleiste unten', en: 'Tap the Share icon in the Safari toolbar at the bottom' },
  nav_ios_step2:       { de: 'Scrolle und wähle „Zum Home-Bildschirm"', en: 'Scroll and select "Add to Home Screen"' },
  nav_ios_step3:       { de: 'Tippe oben rechts auf „Hinzufügen"', en: 'Tap "Add" in the top right' },
  nav_how_ios:         { de: 'SO GEHT\'S AUF IOS', en: 'HOW TO ON IOS' },
  nav_config:          { de: 'CONFIG',          en: 'CONFIG' },
  nav_powered_by:      { de: 'powered by Crit Roster', en: 'powered by Crit Roster' },
  nav_role_owner:      { de: 'OWNER',           en: 'OWNER' },
  nav_role_manager:    { de: 'TEAM MANAGER',    en: 'TEAM MANAGER' },
  nav_role_rider:      { de: 'FAHRER',          en: 'RIDER' },
  nav_team_logo:       { de: 'Team Logo',       en: 'Team Logo' },
  nav_team_name:       { de: 'Teamname',        en: 'Team Name' },
  nav_primary_color:   { de: 'Hauptfarbe',      en: 'Primary Color' },
  nav_pw_change:       { de: 'Passwort ändern', en: 'Change Password' },
  nav_pw_current:      { de: 'AKTUELLES PASSWORT', en: 'CURRENT PASSWORD' },
  nav_pw_new:          { de: 'NEUES PASSWORT',  en: 'NEW PASSWORD' },
  nav_pw_confirm:      { de: 'BESTÄTIGEN',      en: 'CONFIRM' },
  nav_pw_save:         { de: 'Speichern',       en: 'Save' },
  nav_remove:          { de: 'Entfernen',       en: 'Remove' },
  nav_reset:           { de: 'Reset',           en: 'Reset' },
  nav_admin_only:      { de: 'NUR ADMIN',       en: 'ADMIN ONLY' },
  nav_err_pw_match:    { de: 'Passwörter stimmen nicht überein', en: 'Passwords do not match' },
  nav_err_pw_short:    { de: 'Neues Passwort muss mindestens 6 Zeichen haben', en: 'New password must be at least 6 characters' },
  nav_pw_success:      { de: 'Passwort erfolgreich geändert', en: 'Password changed successfully' },
  nav_err_save:        { de: 'Fehler beim Speichern', en: 'Error saving' },
  nav_err_change:      { de: 'Fehler beim Ändern', en: 'Error changing' },
  nav_push_disabled:   { de: 'Push-Benachrichtigungen deaktiviert.', en: 'Push notifications disabled.' },
  nav_push_enabled:    { de: 'Push-Benachrichtigungen aktiviert!', en: 'Push notifications enabled!' },
  nav_push_denied:     { de: 'Berechtigung nicht erteilt.', en: 'Permission not granted.' },

  // ── Demo ────────────────────────────────────────────────────────
  landing_demo_cta:    { de: 'DEMO ANSEHEN →',   en: 'VIEW DEMO →' },
  nav_demo_mode:       { de: 'DEMO-MODUS',        en: 'DEMO MODE' },
  nav_demo_readonly:   { de: 'Nur Lesezugriff. Keine Änderungen möglich.', en: 'Read-only mode. No changes possible.' },
  nav_demo_start_free: { de: 'KOSTENLOS STARTEN →', en: 'GET STARTED FREE →' },
  nav_demo_end:        { de: 'DEMO BEENDEN',      en: 'END DEMO' },
  nav_demo_mobile_start:{ de: 'STARTEN →',        en: 'GET STARTED →' },

  // ── Impressum ────────────────────────────────────────────────────
  impressum_back:      { de: '← ZURÜCK',          en: '← BACK' },
  impressum_title:     { de: 'IMPRESSUM',         en: 'LEGAL NOTICE' },
  impressum_tmg_label: { de: 'ANGABEN GEMÄSS § 5 TMG', en: 'INFORMATION ACCORDING TO § 5 TMG' },
  impressum_contact_label: { de: 'KONTAKT',       en: 'CONTACT' },
  impressum_responsible_label: { de: 'VERANTWORTLICH FÜR DEN INHALT NACH § 55 ABS. 2 RSTV', en: 'RESPONSIBLE FOR CONTENT PURSUANT TO § 55 PARA. 2 RSTV' },
  impressum_liability_content_label: { de: 'HAFTUNG FÜR INHALTE', en: 'LIABILITY FOR CONTENT' },
  impressum_liability_content_text: {
    de: 'Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.',
    en: 'As a service provider, we are responsible for our own content on these pages in accordance with general law pursuant to § 7 para. 1 TMG. However, pursuant to §§ 8 to 10 TMG, we are not obliged as a service provider to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general law remain unaffected by this.',
  },
  impressum_liability_links_label: { de: 'HAFTUNG FÜR LINKS', en: 'LIABILITY FOR LINKS' },
  impressum_liability_links_text: {
    de: 'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
    en: 'Our website contains links to external third-party websites over whose content we have no control. We therefore cannot accept any liability for this third-party content. The respective provider or operator of the linked pages is always responsible for their content.',
  },
  impressum_copyright_label: { de: 'URHEBERRECHT', en: 'COPYRIGHT' },
  impressum_copyright_text: {
    de: 'Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.',
    en: 'The content and works created by the site operator on these pages are subject to German copyright law. Reproduction, editing, distribution and any kind of use outside the limits of copyright require the written consent of the respective author or creator. Downloads and copies of this page are only permitted for private, non-commercial use.',
  },

  // ── Login ───────────────────────────────────────────────────────
  login_title:         { de: 'Anmelden',        en: 'Sign in' },
  login_team:          { de: 'Team',            en: 'Team' },
  login_rider:         { de: 'Fahrer',          en: 'Rider' },
  login_email:         { de: 'E-Mail',          en: 'Email' },
  login_password:      { de: 'Passwort',        en: 'Password' },
  login_btn:           { de: 'Einloggen',       en: 'Sign in' },
  login_no_account:    { de: 'Noch kein Team?', en: 'No team yet?' },
  login_register:      { de: 'Team registrieren', en: 'Register team' },
  login_register_rider:{ de: 'Als Fahrer registrieren', en: 'Register as rider' },
  login_forgot_pw:     { de: 'PASSWORT VERGESSEN?',    en: 'FORGOT PASSWORD?' },
  login_wrong_driver:  { de: 'Diese E-Mail ist als Fahrer-Account registriert. Bitte wähle den Fahrer-Login.',    en: 'This email is registered as a rider account. Please use the rider login.' },
  login_wrong_admin:   { de: 'Diese E-Mail ist als Team-Account registriert. Bitte wähle den Team-Login.',        en: 'This email is registered as a team account. Please use the team login.' },
  login_tab_driver:    { de: 'FAHRER / MANAGER LOGIN',  en: 'RIDER / MANAGER LOGIN' },
  login_tab_admin:     { de: 'TEAM OWNER LOGIN',        en: 'TEAM OWNER LOGIN' },
  reg_exists_driver:   { de: 'Diese E-Mail ist bereits als Fahrer-Account registriert. Bitte einloggen.',         en: 'This email is already registered as a rider account. Please log in.' },
  reg_exists_team:     { de: 'Diese E-Mail ist bereits als Team-Account registriert. Bitte einloggen.',           en: 'This email is already registered as a team account. Please log in.' },

  // ── Email verification banner ───────────────────────────────────
  banner_verify_title:  { de: 'E-MAIL-ADRESSE NICHT BESTÄTIGT',     en: 'EMAIL NOT VERIFIED' },
  banner_verify_text:   { de: 'Bitte bestätige deine E-Mail-Adresse. Sieh in deinem Postfach nach.', en: 'Please verify your email address. Check your inbox.' },
  banner_verify_resend: { de: 'ERNEUT SENDEN',    en: 'RESEND EMAIL' },
  banner_verify_sent:   { de: 'GESENDET ✓',       en: 'SENT ✓' },
  banner_verify_check:  { de: 'BEREITS BESTÄTIGT?', en: 'ALREADY VERIFIED?' },
  login_beta_text:     { de: 'critroster.cc ist kostenlos nutzbar. Neue Funktionen kommen laufend dazu. Feedback ist willkommen — schreib einfach an', en: 'critroster.cc is free to use. New features ship regularly. Feedback is always welcome — just write to' },
  login_tagline:       { de: 'Made with ❤️ for crits', en: 'Made with ❤️ for crits' },
  login_error:         { de: 'Login fehlgeschlagen', en: 'Login failed' },
  login_impressum:     { de: 'IMPRESSUM',       en: 'LEGAL NOTICE' },

  // ── Landing page content ─────────────────────────────────────────
  landing_intro1: {
    de: 'Der Crit Roster ist die Starterliste eines Criterium-Rennens — er zeigt, wer fährt, in welcher Klasse, und für welches Team. In der Realität bedeutet das: Excel-Listen, WhatsApp-Gruppen, und am Ende weiß trotzdem keiner ob er angemeldet ist.',
    en: 'The Crit Roster is the start list of a criterium race — it shows who\'s racing, in which class, and for which team. In reality that means: Excel sheets, WhatsApp groups, and nobody knows if they\'re actually registered.',
  },
  landing_intro2: {
    de: 'critroster.cc löst genau das. Eine Plattform für Crit-Teams: Events anlegen, Fahrer anmelden, Starterlisten verwalten — alles an einem Ort, ohne Chaos.',
    en: 'critroster.cc solves exactly that. One platform for crit teams: create events, register riders, manage start lists — all in one place, no chaos.',
  },
  landing_features_label: { de: 'CORE FEATURES', en: 'CORE FEATURES' },
  landing_feat1_title: { de: 'Events & Starterlisten', en: 'Events & Start Lists' },
  landing_feat1_text:  { de: 'Alle Rennen auf einen Blick — wer fährt, wer hat abgesagt, wer hat noch nicht geantwortet.', en: 'All races at a glance — who\'s in, who pulled out, who hasn\'t responded yet.' },
  landing_feat2_title: { de: 'Push-Benachrichtigungen', en: 'Push Notifications' },
  landing_feat2_text:  { de: 'Automatische Erinnerungen 5 und 2 Tage vor dem Rennen. Direkt aufs Smartphone, ohne dass jemand nachhaken muss.', en: 'Automatic reminders 5 and 2 days before race day. Straight to the phone — no one has to chase anyone.' },
  landing_feat3_title: { de: 'Rollen & Rechte', en: 'Roles & Permissions' },
  landing_feat3_text:  { de: 'Der Team Owner legt das Team an. Fahrer melden sich selbst an und ab. Co-Admins können mitverwalten.', en: 'The team owner creates the team. Riders register and unregister themselves. Co-admins can help manage.' },
  landing_feat4_title: { de: 'Funktioniert als App', en: 'Works as an App' },
  landing_feat4_text:  { de: 'Einfach zur Startseite hinzufügen — fertig. Kein App Store, kein Update-Zwang.', en: 'Just add to home screen — done. No app store, no forced updates.' },
  landing_hint_owner:  { de: 'Du erstellst das Team und vergibst Rollen. Noch kein Konto?', en: 'You create the team and assign roles. No account yet?' },
  landing_hint_rider:  { de: 'Alle Mitglieder starten als Fahrer — Rechte vergibt der Owner. Noch kein Konto?', en: 'All members start as riders — the owner assigns roles. No account yet?' },
  landing_start_free:  { de: 'KOSTENLOS STARTEN →', en: 'START FOR FREE →' },
  landing_start_sub:   { de: 'Kein Kreditkarte. Kein Ablaufdatum.', en: 'No credit card. No expiry.' },
  landing_social_proof:{ de: 'Kostenlos für Teams jeder Größe', en: 'Free for teams of any size' },

  // ── Register ────────────────────────────────────────────────────
  register_title:      { de: 'Team registrieren', en: 'Register team' },
  register_name:       { de: 'Teamname',        en: 'Team name' },
  register_email:      { de: 'E-Mail',          en: 'Email' },
  register_password:   { de: 'Passwort',        en: 'Password' },
  register_btn:        { de: 'Registrieren',    en: 'Register' },
  register_back:       { de: 'Zurück zum Login', en: 'Back to login' },
  register_success:    { de: 'Team erfolgreich registriert!', en: 'Team registered successfully!' },
  register_team_create:{ de: 'NEUES TEAM ERSTELLEN', en: 'CREATE NEW TEAM' },
  register_team_info:  { de: 'Als Team Owner erstellst du das Team, verwaltest Events und vergibst danach Rollen an deine Fahrer. Wähle einen eindeutigen Teamnamen — er wird in der App als Branding verwendet.', en: 'As Team Owner you create the team, manage events, and assign roles to your riders. Choose a unique team name — it will be used as branding throughout the app.' },
  register_teamname:   { de: 'Teamname', en: 'Team Name' },
  register_pw_confirm: { de: 'Passwort bestätigen', en: 'Confirm Password' },
  register_pw_min:     { de: 'Min. 6 Zeichen', en: 'Min. 6 characters' },
  register_team_btn:   { de: 'TEAM ERSTELLEN', en: 'CREATE TEAM' },
  register_loading:    { de: 'REGISTRIEREN...', en: 'REGISTERING...' },
  register_already:    { de: 'Bereits registriert?', en: 'Already have an account?' },
  register_signin:     { de: 'Anmelden', en: 'Sign in' },
  register_failed:     { de: 'Registrierung fehlgeschlagen', en: 'Registration failed' },

  // ── Driver Register ─────────────────────────────────────────────
  driver_register_title:  { de: 'Als Fahrer registrieren', en: 'Register as rider' },
  driver_register_btn:    { de: 'Registrieren', en: 'Register' },
  driver_register_back:   { de: 'Zurück zum Login', en: 'Back to login' },
  driver_register_create: { de: 'KONTO ERSTELLEN', en: 'CREATE ACCOUNT' },
  driver_register_info:   { de: 'Alle Mitglieder starten als Fahrer. Nach der Registrierung kannst du dein Profil vervollständigen und einem Team beitreten — per Einladung oder Bewerbung. Der Team Owner kann dir später Manager-Rechte vergeben.', en: 'All members start as riders. After registering you can complete your profile and join a team — by invitation or application. The Team Owner can grant you manager rights later.' },
  driver_register_fullname:{ de: 'Vor- und Nachname', en: 'Full Name' },
  driver_register_loading: { de: 'REGISTRIEREN...', en: 'REGISTERING...' },

  // ── Email verification ──────────────────────────────────────────
  verify_inbox_title:  { de: 'Postfach prüfen',          en: 'Check your inbox' },
  verify_inbox_text:   { de: 'Wir haben dir eine Bestätigungs-E-Mail geschickt. Klicke den Link darin, um dein Konto zu aktivieren. Die E-Mail kann ein paar Minuten brauchen.', en: 'We sent you a confirmation email. Click the link inside to activate your account. It may take a few minutes to arrive.' },
  verify_go_app:       { de: 'ZUR APP →',                en: 'GO TO APP →' },
  verify_resend:       { de: 'E-MAIL ERNEUT SENDEN',     en: 'RESEND EMAIL' },
  verify_resending:    { de: 'SENDEN...',                 en: 'SENDING...' },
  verify_resent:       { de: 'E-MAIL GESENDET ✓',        en: 'EMAIL SENT ✓' },
  verify_checking:     { de: 'Verifiziere...',            en: 'Verifying...' },
  verify_success_title:{ de: 'E-Mail bestätigt ✓',       en: 'Email confirmed ✓' },
  verify_success_text: { de: 'Dein Konto ist jetzt aktiv. Du kannst dich einloggen.', en: 'Your account is now active. You can log in.' },
  verify_go_login:     { de: 'ZUM LOGIN →',              en: 'GO TO LOGIN →' },
  verify_error_title:  { de: 'Link abgelaufen',           en: 'Link expired' },
  verify_error_text:   { de: 'Der Bestätigungs-Link ist ungültig oder abgelaufen. Logge dich ein und fordere einen neuen Link an.', en: 'The confirmation link is invalid or expired. Log in and request a new link.' },
  verify_go_home:      { de: 'ZUR STARTSEITE',           en: 'GO TO HOME' },

  // ── Forgot password ─────────────────────────────────────────────
  forgot_title:        { de: 'Passwort vergessen?',      en: 'Forgot password?' },
  forgot_subtitle:     { de: 'Gib deine E-Mail-Adresse ein. Wir schicken dir einen Link zum Zurücksetzen.', en: 'Enter your email address and we\'ll send you a reset link.' },
  forgot_send:         { de: 'LINK SENDEN →',            en: 'SEND LINK →' },
  forgot_sending:      { de: 'SENDEN...',                 en: 'SENDING...' },
  forgot_sent_title:   { de: 'E-Mail gesendet',           en: 'Email sent' },
  forgot_sent_text:    { de: 'Falls ein Konto mit dieser E-Mail existiert, haben wir einen Reset-Link verschickt. Er ist 1 Stunde gültig.', en: 'If an account with that email exists, we\'ve sent a reset link. It\'s valid for 1 hour.' },
  forgot_back_login:   { de: 'ZURÜCK ZUM LOGIN',         en: 'BACK TO LOGIN' },

  // ── Reset password ──────────────────────────────────────────────
  reset_title:         { de: 'Neues Passwort',           en: 'New password' },
  reset_subtitle:      { de: 'Wähle ein neues Passwort für dein Konto.', en: 'Choose a new password for your account.' },
  reset_new_pw:        { de: 'Neues Passwort',           en: 'New password' },
  reset_save:          { de: 'PASSWORT SPEICHERN →',     en: 'SAVE PASSWORD →' },
  reset_success_title: { de: 'Passwort gespeichert ✓',   en: 'Password saved ✓' },
  reset_success_text:  { de: 'Du kannst dich jetzt mit deinem neuen Passwort einloggen.', en: 'You can now log in with your new password.' },
  reset_invalid_title: { de: 'Link ungültig',            en: 'Invalid link' },
  reset_invalid_text:  { de: 'Dieser Reset-Link ist nicht mehr gültig. Fordere einen neuen an.', en: 'This reset link is no longer valid. Request a new one.' },
  reset_request_new:   { de: 'NEUEN LINK ANFORDERN →',   en: 'REQUEST NEW LINK →' },
  reset_error_generic: { de: 'Fehler beim Speichern. Bitte neuen Link anfordern.', en: 'Error saving password. Please request a new link.' },

  // ── Dashboard ───────────────────────────────────────────────────
  dashboard_title:     { de: 'Dashboard',       en: 'Dashboard' },
  dashboard_next_event:{ de: 'Nächstes Event',  en: 'Next event' },
  dashboard_no_events: { de: 'Keine Events geplant', en: 'No events planned' },
  dashboard_riders:    { de: 'Fahrer',          en: 'Riders' },
  dashboard_events:    { de: 'Events',          en: 'Events' },
  dashboard_registered:{ de: 'Angemeldet',      en: 'Registered' },
  dashboard_team_roster:{ de: 'TEAM ROSTER',    en: 'TEAM ROSTER' },
  dashboard_no_riders: { de: 'Noch keine Fahrer im Team', en: 'No riders in team yet' },
  dashboard_status_open:{ de: 'Offen',          en: 'Open' },
  dashboard_view_all:  { de: 'Alle anzeigen',   en: 'View all' },

  // ── Drivers ─────────────────────────────────────────────────────
  drivers_title:       { de: 'TEAM ROSTER',     en: 'TEAM ROSTER' },
  drivers_add:         { de: 'Fahrer hinzufügen', en: 'Add rider' },
  drivers_invite:      { de: 'Fahrer einladen', en: 'Invite rider' },
  drivers_search:      { de: 'Suche…',          en: 'Search…' },
  drivers_all_classes: { de: 'Alle Klassen',    en: 'All classes' },
  drivers_all_genders: { de: 'Alle',            en: 'All' },
  drivers_col_pts:     { de: 'PTS',             en: 'PTS' },
  drivers_col_rider:   { de: 'FAHRER',          en: 'RIDER' },
  drivers_col_id:      { de: 'FAHRER-ID',       en: 'RIDER ID' },
  drivers_col_class:   { de: 'KLASSE',          en: 'CLASS' },
  drivers_not_found:   { de: 'KEINE FAHRER GEFUNDEN', en: 'NO RIDERS FOUND' },
  drivers_badge_me:    { de: 'ICH',             en: 'ME' },
  drivers_badge_owner: { de: 'TEAM OWNER',      en: 'TEAM OWNER' },
  drivers_badge_manager:{ de: 'TEAM MANAGER',   en: 'TEAM MANAGER' },
  drivers_badge_not_racing:{ de: 'NOT RACING',  en: 'NOT RACING' },
  drivers_form_name:   { de: 'Name',            en: 'Name' },
  drivers_form_email:  { de: 'Login E-Mail',    en: 'Login email' },
  drivers_form_password:{ de: 'Login Passwort', en: 'Login password' },
  drivers_form_license:{ de: 'Lizenznummer',    en: 'License number' },
  drivers_form_uci:    { de: 'UCI ID',          en: 'UCI ID' },
  drivers_form_phone:  { de: 'Telefon',         en: 'Phone' },
  drivers_form_dob:    { de: 'Geburtsdatum',    en: 'Date of birth' },
  drivers_form_emergency:{ de: 'Notfallkontakt', en: 'Emergency contact' },
  drivers_form_address:{ de: 'Adresse',         en: 'Address' },
  drivers_form_points: { de: 'Punkte',          en: 'Points' },
  drivers_form_class:  { de: 'Klasse',          en: 'Class' },
  drivers_form_gender: { de: 'Geschlecht',      en: 'Gender' },
  drivers_form_gender_m:{ de: 'Männlich',       en: 'Male' },
  drivers_form_gender_f:{ de: 'Weiblich',       en: 'Female' },
  drivers_form_gender_nb:{ de: 'Divers',        en: 'Non-binary' },
  drivers_save:        { de: 'Speichern',       en: 'Save' },
  drivers_cancel:      { de: 'Abbrechen',       en: 'Cancel' },
  drivers_delete:      { de: 'Fahrer löschen',  en: 'Delete rider' },
  drivers_confirm_delete:{ de: 'Fahrer wirklich löschen?', en: 'Really delete this rider?' },
  drivers_set_account: { de: 'Login setzen',    en: 'Set login' },
  drivers_join_request:{ de: 'Beitrittsanfragen', en: 'Join requests' },
  drivers_accept:      { de: 'Annehmen',        en: 'Accept' },
  drivers_decline:     { de: 'Ablehnen',        en: 'Decline' },
  drivers_invite_search:{ de: 'Fahrer suchen…', en: 'Search riders…' },
  drivers_invite_send: { de: 'Einladen',        en: 'Invite' },
  drivers_invite_again:{ de: 'Erneut einladen', en: 'Invite again' },
  drivers_invite_sent: { de: 'Einladung gesendet', en: 'Invitation sent' },
  drivers_invite_hint: { de: 'Suche nach Fahrern ohne Team — nach Name, E-Mail oder Fahrer-ID.', en: 'Search for riders without a team — by name, email, or rider ID.' },
  drivers_invite_placeholder:{ de: 'Name, E-Mail oder Fahrer-ID…', en: 'Name, email, or rider ID…' },
  drivers_invite_no_results:{ de: 'Kein Fahrer gefunden.', en: 'No riders found.' },
  drivers_invite_no_team:{ de: 'Keine Fahrer ohne Team verfügbar.', en: 'No riders without a team available.' },
  // (drivers_add + drivers_save defined above — removed duplicate keys)
  drivers_msg_updated: { de: 'Fahrer aktualisiert', en: 'Rider updated' },
  drivers_msg_added:   { de: 'Fahrer hinzugefügt', en: 'Rider added' },
  drivers_msg_removed: { de: 'Fahrer aus dem Team entfernt.', en: 'Rider removed from team.' },
  drivers_confirm_remove:{ de: 'Fahrer aus dem Team entfernen? Sein Login-Account bleibt erhalten.', en: 'Remove rider from team? Their login account will be kept.' },
  drivers_my_profile:  { de: 'Mein Profil',     en: 'My Profile' },
  drivers_form_new:    { de: 'Neu',             en: 'New' },
  drivers_form_new_title:{ de: 'Neuer Fahrer',  en: 'New Rider' },
  drivers_form_edit:   { de: 'Fahrer bearbeiten', en: 'Edit Rider' },
  drivers_form_section_basic:{ de: 'Stammdaten', en: 'Personal Info' },
  drivers_form_section_sport:{ de: 'Lizenz & Sport', en: 'License & Sport' },
  drivers_form_section_login:{ de: 'Login-Zugang', en: 'Login Access' },
  // (drivers_form_email defined above — removed duplicate key)
  drivers_form_pw_optional:{ de: 'Neues Passwort (optional)', en: 'New password (optional)' },

  // ── Events ──────────────────────────────────────────────────────
  events_title:        { de: 'UNSERE EVENTS',   en: 'OUR EVENTS' },
  events_title_mobile: { de: 'Unsere Events',   en: 'Our Events' },
  events_add:          { de: 'Event erstellen', en: 'Create event' },
  events_no_events:    { de: 'Keine Events geplant', en: 'No events planned' },
  events_loading:      { de: 'Lade Events…',    en: 'Loading events…' },
  events_tab_upcoming: { de: 'Bevorstehend',    en: 'Upcoming' },
  events_tab_past:     { de: 'Vergangen',       en: 'Past' },
  events_mandatory:    { de: 'Pflichttermin',   en: 'Mandatory' },
  events_mandatory_desc:{ de: 'Alle Fahrer müssen an diesem Termin teilnehmen', en: 'All riders must attend this event' },
  events_count_races:  { de: 'Rennen',          en: 'Races' },
  events_empty_upcoming:{ de: 'Keine bevorstehenden Veranstaltungen', en: 'No upcoming events' },
  events_empty_past:   { de: 'Keine vergangenen Veranstaltungen', en: 'No past events' },
  events_msg_updated:  { de: 'Veranstaltung aktualisiert', en: 'Event updated' },
  events_msg_created:  { de: 'Veranstaltung erstellt', en: 'Event created' },
  events_msg_deleted:  { de: 'Veranstaltung gelöscht', en: 'Event deleted' },
  events_msg_delete_error:{ de: 'Fehler beim Löschen', en: 'Error deleting' },
  events_register:     { de: 'Anmelden',        en: 'Register' },
  events_unregister:   { de: 'Abmelden',        en: 'Unregister' },
  events_registered:   { de: 'Angemeldet',      en: 'Registered' },
  events_filter_all:   { de: 'Alle',            en: 'All' },
  events_filter_upcoming:{ de: 'Kommend',       en: 'Upcoming' },
  events_filter_past:  { de: 'Vergangen',       en: 'Past' },
  events_date:         { de: 'Datum',           en: 'Date' },
  events_location:     { de: 'Ort',             en: 'Location' },
  events_category:     { de: 'Kategorie',       en: 'Category' },
  events_riders_registered:{ de: 'Fahrer angemeldet', en: 'riders registered' },
  events_send_reminder:{ de: 'Reminder senden', en: 'Send reminder' },
  events_edit:         { de: 'Bearbeiten',      en: 'Edit' },
  events_delete:       { de: 'Löschen',         en: 'Delete' },
  events_confirm_delete:{ de: 'Veranstaltung wirklich löschen?', en: 'Really delete this event?' },
  events_form_new:     { de: 'Neue Veranstaltung', en: 'New Event' },
  events_form_section_general:{ de: 'Allgemein', en: 'General' },
  events_form_section_cats:{ de: 'Rennklassen & Startzeiten', en: 'Race Classes & Start Times' },
  events_form_name:    { de: 'Eventname',       en: 'Event name' },
  events_form_date:    { de: 'Datum',           en: 'Date' },
  events_form_location:{ de: 'Ort',             en: 'Location' },
  events_form_track_type:{ de: 'Streckentyp',   en: 'Track type' },
  events_form_track_length:{ de: 'Streckenlänge (Meter)', en: 'Track length (meters)' },
  events_form_url:     { de: 'Ausschreibung (URL)', en: 'Race flyer (URL)' },
  events_form_desc:    { de: 'Beschreibung',    en: 'Description' },
  events_form_desc_placeholder:{ de: 'Weitere Infos…', en: 'Additional info…' },
  events_form_select:  { de: 'Auswählen',       en: 'Select' },
  events_form_category:{ de: 'Kategorie',       en: 'Category' },
  events_form_update:  { de: 'Aktualisieren',   en: 'Update' },
  events_form_create:  { de: 'Erstellen',       en: 'Create' },
  events_form_save:    { de: 'Speichern',       en: 'Save' },
  events_form_cancel:  { de: 'Abbrechen',       en: 'Cancel' },
  events_participation_open:{ de: 'Offen',      en: 'Open' },
  events_participation_closed:{ de: 'Geschlossen', en: 'Closed' },

  // ── Event Detail ────────────────────────────────────────────────
  evdetail_loading:         { de: 'Lade Event…',           en: 'Loading event…' },
  evdetail_not_found:       { de: 'Event nicht gefunden',  en: 'Event not found' },
  evdetail_back_mobile:     { de: 'Events',                en: 'Events' },
  evdetail_back:            { de: 'Zurück zu Events',      en: 'Back to Events' },
  evdetail_share:           { de: 'Teilen',                en: 'Share' },
  evdetail_mandatory:       { de: 'Pflichttermin',         en: 'Mandatory' },
  evdetail_past:            { de: 'Vergangen',             en: 'Past' },
  evdetail_today:           { de: 'Heute',                 en: 'Today' },
  evdetail_stat_registered: { de: 'Angemeldet',            en: 'Registered' },
  evdetail_stat_open:       { de: 'Offen',                 en: 'Open' },
  evdetail_stat_classes:    { de: 'Klassen',               en: 'Classes' },
  evdetail_stat_status:     { de: 'Status',                en: 'Status' },
  evdetail_my_reg:          { de: 'Meine Anmeldung',       en: 'My Registration' },
  evdetail_is_reg:          { de: 'Ist angemeldet',        en: 'Is registered' },
  evdetail_was_reg:         { de: 'War angemeldet',        en: 'Was registered' },
  evdetail_not_reg:         { de: 'Abgemeldet',            en: 'Not registered' },
  evdetail_registered:      { de: 'Angemeldet',            en: 'Registered' },
  evdetail_unregister:      { de: 'Vom Event abmelden',    en: 'Unregister from event' },
  evdetail_unregister_short:{ de: 'Abmelden',              en: 'Unregister' },
  evdetail_cancelled:       { de: 'Abgesagt',              en: 'Cancelled' },
  evdetail_register_anyway: { de: 'Doch anmelden',         en: 'Register anyway' },
  evdetail_no_response:     { de: 'Noch keine Rückmeldung', en: 'No response yet' },
  evdetail_im_in:           { de: 'Ich bin dabei',         en: 'I\'m in' },
  evdetail_cant_make_it:    { de: 'Ich kann nicht',        en: 'Can\'t make it' },
  evdetail_in:              { de: 'Dabei',                 en: 'In' },
  evdetail_out:             { de: 'Absagen',               en: 'Out' },
  evdetail_in_short:        { de: 'dabei',                 en: 'in' },
  evdetail_rider_status:    { de: 'Fahrer — Status',       en: 'Rider — Status' },
  evdetail_send_reminder:   { de: 'Erinnerung senden',     en: 'Send reminder' },
  evdetail_no_answer:       { de: 'ohne Antwort',          en: 'no answer' },
  evdetail_race_flyer:      { de: 'Ausschreibung',         en: 'Race flyer' },
  evdetail_register_rider:  { de: 'Fahrer anmelden',       en: 'Register rider' },
  evdetail_register_btn:    { de: 'Anmelden',              en: 'Register' },
  evdetail_all_registered:  { de: 'Alle angemeldet',       en: 'All registered' },
  evdetail_all_riders_status:{ de: 'Alle Fahrer — Statusverwaltung', en: 'All Riders — Status' },
  evdetail_rider_count:     { de: 'Fahrer',                en: 'Riders' },
  evdetail_field_date:      { de: 'Datum',                 en: 'Date' },
  evdetail_field_location:  { de: 'Ort',                   en: 'Location' },
  evdetail_field_length:    { de: 'Länge',                 en: 'Length' },
  evdetail_remind:          { de: 'Erinnern',              en: 'Remind' },
  evdetail_remind_title:    { de: 'Erinnerung senden an',  en: 'Send reminder to' },
  evdetail_sending:         { de: 'Sende…',                en: 'Sending…' },
  evdetail_confirm_unregister: { de: 'Anmeldung von',      en: 'Remove registration of' },
  evdetail_this_rider:      { de: 'diesem Fahrer',         en: 'this rider' },
  evdetail_unregistered_ok: { de: 'Abgemeldet',            en: 'Unregistered' },
  evdetail_unregister_error:{ de: 'Fehler beim Abmelden',  en: 'Error unregistering' },
  // (drivers_badge_me defined above — removed duplicate key)

  // ── Race Matrix ─────────────────────────────────────────────────
  matrix_title:         { de: 'RENNTEILNAHMEN',     en: 'RACE MATRIX' },
  matrix_no_events:     { de: 'Keine Events',        en: 'No events' },
  matrix_no_events_found:{ de: 'Keine Events vorhanden', en: 'No events found' },
  matrix_rider:         { de: 'FAHRER',              en: 'RIDER' },
  matrix_status_in:     { de: 'AN',                  en: 'IN' },
  matrix_status_out:    { de: 'AB',                  en: 'OUT' },
  matrix_status_open:   { de: '—',                   en: '—' },
  matrix_upcoming:      { de: 'Kommende',             en: 'Upcoming' },
  matrix_past:          { de: 'Vergangene',           en: 'Past' },
  matrix_upcoming_races:{ de: 'Kommende Rennen',      en: 'Upcoming Races' },
  matrix_in_squad:      { de: 'Im Kader',             en: 'In squad' },
  matrix_registrations: { de: 'Anmeldungen',          en: 'Registrations' },
  matrix_confirmed:     { de: 'Bestätigt',            en: 'Confirmed' },
  matrix_rate:          { de: 'Teilnahmequote',       en: 'Participation Rate' },

  // ── Notifications ───────────────────────────────────────────────
  notif_title:         { de: 'Benachrichtigungen', en: 'Notifications' },
  notif_empty:         { de: 'Keine Benachrichtigungen', en: 'No notifications' },
  notif_mark_read:     { de: 'Alle gelesen',    en: 'Mark all read' },
  notif_tab_team:      { de: 'Team',            en: 'Team' },
  notif_tab_racing:    { de: 'Rennen',          en: 'Racing' },

  // ── Dashboard ───────────────────────────────────────────────────
  dashboard_next_events: { de: 'Die nächsten Events', en: 'Upcoming Events' },

  // ── Profile / DriverProfile ─────────────────────────────────────
  profile_title:       { de: 'Mein Profil',     en: 'My Profile' },
  profile_edit:        { de: 'Bearbeiten',      en: 'Edit' },
  profile_save:        { de: 'Speichern',       en: 'Save' },
  profile_cancel:      { de: 'Abbrechen',       en: 'Cancel' },
  profile_name:        { de: 'Name',            en: 'Name' },
  profile_email:       { de: 'E-Mail',          en: 'Email' },
  profile_phone:       { de: 'Telefon',         en: 'Phone' },
  profile_dob:         { de: 'Geburtsdatum',    en: 'Date of birth' },
  profile_license:     { de: 'Lizenznummer',    en: 'License number' },
  profile_uci:         { de: 'UCI ID',          en: 'UCI ID' },
  profile_class:       { de: 'Klasse',          en: 'Class' },
  profile_gender:      { de: 'Geschlecht',      en: 'Gender' },
  profile_points:      { de: 'Punkte',          en: 'Points' },
  profile_emergency:   { de: 'Notfallkontakt',  en: 'Emergency contact' },
  profile_address:     { de: 'Adresse',         en: 'Address' },
  profile_photo:       { de: 'Foto ändern',     en: 'Change photo' },
  profile_leave_team:  { de: 'Team verlassen',  en: 'Leave team' },
  profile_confirm_leave:{ de: 'Team wirklich verlassen?', en: 'Really leave the team?' },
  profile_no_team:     { de: 'Kein Team',       en: 'No team' },
  profile_join_team:   { de: 'Team beitreten',  en: 'Join a team' },
  profile_section_personal: { de: 'Persönliche Daten', en: 'Personal Data' },
  profile_section_race:     { de: 'Renndaten',         en: 'Race Data' },
  profile_full_name:        { de: 'Vollständiger Name *', en: 'Full name *' },
  profile_change_pw:        { de: 'Passwort ändern',   en: 'Change password' },
  profile_pw_mismatch:      { de: 'Passwörter stimmen nicht überein', en: 'Passwords do not match' },
  profile_pw_confirm:       { de: 'Passwort zur Bestätigung', en: 'Confirm password' },
  profile_delete_account:   { de: 'Account löschen',   en: 'Delete account' },
  profile_delete_confirm:   { de: 'Endgültig löschen', en: 'Delete permanently' },
  profile_pw_changed:       { de: 'Passwort geändert',  en: 'Password changed' },

  // ── Owner Profile ───────────────────────────────────────────────
  owner_title:         { de: 'Owner Profil',    en: 'Owner Profile' },
  owner_racing:        { de: 'Ich fahre Rennen', en: 'I race' },
  owner_not_racing:    { de: 'Ich fahre keine Rennen', en: 'I don\'t race' },

  // ── Settings ────────────────────────────────────────────────────
  settings_title:      { de: 'Einstellungen',   en: 'Settings' },
  settings_section_account:{ de: 'Account',     en: 'Account' },
  settings_section_push:{ de: 'Push Notifications', en: 'Push Notifications' },
  settings_section_branding:{ de: 'Team Branding', en: 'Team Branding' },
  settings_section_lang:{ de: 'Sprache',        en: 'Language' },
  settings_push_enable:{ de: 'Aktivieren',      en: 'Enable' },
  settings_push_disable:{ de: 'Deaktivieren',   en: 'Disable' },
  settings_push_desc:  { de: 'Erhalte Benachrichtigungen über Events und Team-Aktivitäten.', en: 'Receive notifications about events and team activities.' },
  settings_lang_de:    { de: 'Deutsch',         en: 'German' },
  settings_lang_en:    { de: 'Englisch',        en: 'English' },
  settings_lang_desc:  { de: 'Sprache der App', en: 'App language' },
  settings_branding_primary:{ de: 'Primärfarbe', en: 'Primary color' },
  settings_branding_secondary:{ de: 'Sekundärfarbe', en: 'Secondary color' },
  settings_branding_logo:{ de: 'Team Logo',     en: 'Team logo' },
  settings_branding_name:{ de: 'Teamname in der App', en: 'Team name in app' },
  settings_branding_preview:{ de: 'Vorschau',   en: 'Preview' },
  settings_branding_save:{ de: 'Branding speichern', en: 'Save branding' },
  settings_branding_saved:{ de: 'Gespeichert!', en: 'Saved!' },
  settings_branding_presets:{ de: 'Farbvorlagen', en: 'Color presets' },
  settings_team_link:  { de: 'Team-Link',       en: 'Team link' },
  settings_team_link_desc:{ de: 'Teile diesen Link mit Fahrern zum Beitreten', en: 'Share this link with riders to join' },
  settings_account_email:{ de: 'E-Mail',        en: 'Email' },
  settings_save:       { de: 'Speichern',       en: 'Save' },
  settings_cancel:     { de: 'Abbrechen',       en: 'Cancel' },

  // ── General / shared ────────────────────────────────────────────
  general_loading:     { de: 'Laden…',          en: 'Loading…' },
  general_error:       { de: 'Fehler',          en: 'Error' },
  general_save:        { de: 'Speichern',       en: 'Save' },
  general_cancel:      { de: 'Abbrechen',       en: 'Cancel' },
  general_delete:      { de: 'Löschen',         en: 'Delete' },
  general_edit:        { de: 'Bearbeiten',      en: 'Edit' },
  general_close:       { de: 'Schließen',       en: 'Close' },
  general_back:        { de: 'Zurück',          en: 'Back' },
  general_yes:         { de: 'Ja',              en: 'Yes' },
  general_no:          { de: 'Nein',            en: 'No' },
  general_total:       { de: 'GESAMT',          en: 'TOTAL' },
  general_all:         { de: 'Alle',            en: 'All' },
  general_none:        { de: '—',               en: '—' },
  general_copy:        { de: 'Kopieren',        en: 'Copy' },
  general_copied:      { de: 'Kopiert!',        en: 'Copied!' },
};

export default translations;

// ── Hook ──────────────────────────────────────────────────────────
export function useT() {
  const { lang } = useContext(LangContext);
  return (key) => {
    const entry = translations[key];
    if (!entry) return key; // fallback: show key
    return entry[lang] || entry.de || key;
  };
}
